<template>
  <div class="page">
    <div class="fixed-top bg-white flex justify-around">

      <!--   状态选择   -->
      <div class="toolbar van-hairline--bottom">
        <div class="tool-item btn-select-sort " @click="clerkCheckStatusSheet.show = true">状态：{{ cherkCheckStatus }}<span
            class="caret"></span></div>
      </div>
    </div>

    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="loadData"
        >
      <van-cell-group class="order-list">
        <van-cell v-for="(item, index) in list" :key="index" :to="'/admin/clerk-category-examine-check-detail?id='+ item.id + '&clerkId=' + item.clerkId" center clickable is-link
                  size="large">
          <div style="display: flex; flex-direction: row;justify-content: space-between">
            <div style="display: flex;flex-direction: row">
              <div>
                <img :src="item.avatarUrl" height="50" style="border-radius: 50%;display: block" width="50"/>
              </div>
              <div style="display: flex;flex-direction: column; margin-left: 10px">
                <div>
                  <span style="margin-left: 10px">{{ item.name }}</span>
                </div>
                <div>
                  <span style="margin-left: 10px">{{ item.categoryName }}</span>
                  <span style="margin-left: 10px;color: lightgrey">|</span>
                  <span v-if="item.grade && item.grade != 0 && ($store.state.shop.id == 154 || $store.state.shop.id == 1)" style="margin-left: 10px">{{ $store.state.ClerkGradeMap[item.grade] }}</span>
                </div>
                <div style="font-size: small">
                  <span style="margin-left: 10px">{{ $store.state.ClerkSexEnum.getLabel(item.sex) }}</span>
                  <span style="margin-left: 10px;color: lightgrey">|</span>
                  <span style="margin-left: 10px">{{ item.regionNames.join('-') }}</span>
                </div>
              </div>
            </div>
            <div style="display: flex;flex-direction: column">
              <div style="display: flex; padding-left: 30px;">
                <van-tag v-if="item.status == 0" plain type="warning">待审核</van-tag>
                <van-tag v-if="item.status == 1" plain type="success">已通过</van-tag>
                <van-tag v-if="item.status == 2" plain>未通过</van-tag>
              </div>
              <div>
                <span style="color: grey">{{ formatDate(item.createTime, 'MM-DD HH:mm') }}</span>
              </div>
            </div>
          </div>
        </van-cell>
      </van-cell-group>
    </van-list>


    <!--上拉选择申请状态-->
    <van-action-sheet
        v-model="clerkCheckStatusSheet.show"
        :actions="clerkCheckStatusSheet.actions"
        cancel-text="取消"
        @select="onClerkCheckStatusSheetChange"/>

  </div>
</template>

<script>
import Vue from 'vue';
import {ActionSheet, Button, Cell, CellGroup, Dialog, Icon, List, Panel, Search, Tab, Tabs, Tag} from 'vant';
import {getClerkCategoryCheckListForAdmin} from '@/api/clerk_category_examine_check'
import moment from "moment";

Vue.use(Tab)
    .use(Tabs)
    .use(Search)
    .use(Button)
    .use(List)
    .use(Cell)
    .use(CellGroup)
    .use(Tag)
    .use(Icon)
    .use(ActionSheet)
    .use(Dialog)
    .use(Panel)

export default {
  name: 'clerk-category-apply-list',
  data() {
    return {
      status: 0,
      clerkCheckStatusSheet: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '待审核', value: 0},
          {name: '已通过', value: 1},
          {name: '未通过', value: 2}
        ]
      },
      list: [],
      loading: false,
      listFinished: false,
      pageNo: 1,
      pageSize: 15
    }
  },
  watch:{
    '$route' () {
      //当路由发生变化，刷新页面
      this.loadData(true)
    }
  },
  computed: {
    cherkCheckStatus() {
      if (this.status == 0) {
        return "待审核"
      }
      if (this.status == 1) {
        return "已通过"
      }
      if (this.status == 2) {
        return "未通过"
      }
      return "全部"
    }
  },
  methods: {
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    onClerkCheckStatusSheetChange(item) {
      this.status = item.value
      this.clerkCheckStatusSheet.show = false
      this.loadData(true)
    },
    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      getClerkCategoryCheckListForAdmin(
          this.status,
          this.pageNo,
          this.pageSize
      ).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
    }
  }
}
</script>

<style lang="less" scoped>

.page {
  padding-top: 44px;
  padding-bottom: 100px;
}

.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  .toolbar {
    height: 44px;
    font-size: 14px;
    background: #fff;
    position: relative;
    display: flex;

    .tool-item {
      position: relative;
      padding: 12px 0;
      text-align: center;
      flex: 1;
    }
  }
}
</style>
